import Vue from 'vue';
import "./assets/styles/main.scss";
import Multiselect from 'vue-multiselect';
import BootstrapVue from 'bootstrap-vue';
import VueHtmlToPaper from 'vue-html-to-paper';
import vueNumeralFilterInstaller from 'vue-numeral-filter';
import BackToTop from 'vue-backtotop';
import VueMeta from 'vue-meta';
import Vuelidate from 'vuelidate';
import moment from 'moment';
import browserDetect from "vue-browser-detect-plugin";
import axios from 'axios';
import Vidle from 'v-idle';
import loaderPlugin from './utils/loader-plugin';
import App from './App.vue';

Vue.config.productionTip = false;

// 🔹 Load env config before mounting app
async function loadEnvConfig() {
    try {
        const response = await fetch("/bandleportalconf.txt");
        if (!response.ok) throw new Error("bandleportalconf.txt not found");

        const encoded = await response.text();
        let decoded = atob(encoded.trim()).replace(/[\r\n]+/g, "");
        window.env = JSON.parse(decoded);
    } catch (err) {
        console.error("Failed to load config:", err);
        window.env = {};
    }
}

// Plugins
Vue.use(BootstrapVue);
Vue.use(VueHtmlToPaper);
Vue.component('multiselect', Multiselect);
Vue.use(vueNumeralFilterInstaller, {
    locale: 'fr',
    delimiters: { thousands: '.', decimal: ',' },
});
Vue.use(BackToTop);
Vue.use(VueMeta, { refreshOnceOnNavigation: true });
Vue.use(Vuelidate);
Vue.use(moment);
Vue.use(browserDetect);
Vue.use(Vidle);
Vue.use(loaderPlugin);

// Moment locale setup
Vue.prototype.moment = moment;
moment.locale('sr-cyrl');
moment.updateLocale('en', {
    monthsShort: [
        "Јан", "Феб", "Мар", "Апр", "Мај", "Јун",
        "Јул", "Авг", "Сеп", "Окт", "Нов", "Дец"
    ]
});



// Wait for config, then mount app
(async () => {
    await loadEnvConfig();
    const { store } = await import('./store');
    const { default: router } = await import("./router");

    // Axios interceptors
    axios.interceptors.request.use(
        config => { config.withCredentials = true; return config; },
        err => Promise.reject(err)
    );
    axios.interceptors.response.use(
        response => response,
        err => {
            if (err.response && err.response.status === 403) {
                store.dispatch("resetUserInfo");
            }
            return Promise.reject(err);
        }
    );

    new Vue({
        store,
        router,
        render: h => h(App)
    }).$mount('#app');
})();